import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { getRegion } from './regions';
import type { AgentListRow, Me, ModelRow } from './types';

/** Query keys are prefixed with the region so switching regions never shows the other region's data. */
export const rk = (...parts: unknown[]) => [getRegion().id, ...parts];

export const useMe = () => useQuery({ queryKey: rk('me'), queryFn: () => api<Me>('/v1/me'), retry: false, staleTime: 60_000 });
export const useAgents = (project?: string) =>
  useQuery({ queryKey: rk('agents', project ?? 'all'), queryFn: () => api<{ agents: AgentListRow[] }>(`/v1/agents${project ? `?project=${project}` : ''}`) });
export const useModels = () => useQuery({ queryKey: rk('models'), queryFn: () => api<{ models: ModelRow[] }>('/v1/models'), staleTime: 60_000 });
export const useProjects = () => useQuery({ queryKey: rk('projects'), queryFn: () => api<{ projects: Array<{ id: string; slug: string; name: string }> }>('/v1/projects'), staleTime: 300_000 });
export const useTools = () =>
  useQuery({
    queryKey: rk('tools'),
    queryFn: () => api<{ manifests: Array<{ project: string; updatedAt: string; tools: Array<{ name: string; description: string; parameters: unknown }> }> }>('/v1/tools'),
    staleTime: 60_000,
  });
export const useAuthMode = () => useQuery({ queryKey: rk('auth-mode'), queryFn: () => api<{ mode: 'dev' | 'cognito' }>('/v1/auth/config', { auth: false }), staleTime: Infinity, retry: 1 });

export const canEdit = (me?: Me) => me?.role === 'admin' || me?.role === 'editor';
export const useSnippets = () => useQuery({ queryKey: rk('snippets'), queryFn: () => api<{ snippets: import('./types').Snippet[] }>('/v1/snippets') });
